import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { ALL_USER_ROLES, hasRoleSunroomClub } from 'common/userRoles';
import { SUNROOM_CLUB_MEMBERSHIP_FEE } from 'common/householdConstants';
import { SR_API_ACTION_JOIN_SUNROOM_CLUB } from 'api/actionTypes';
import { SCREEN_ID_JOIN_SUNROOM_CLUB } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedRoles from 'client/helpers/allowedRoles';
import withScreenId from 'client/helpers/withScreenId';
import withApiState from 'client/helpers/withApiState';
import withScrollToTop from 'client/helpers/withScrollToTop';
import branch from 'client/core/branch';
import log from 'client/lib/log';

import joinSunroomClubAction from 'client/actions/Auth/joinSunroomClub';

import Navbar from 'client/components/Navbar';
import TabBar from 'client/components/TabBar';
import SrStripeCardForm from 'client/components/SrStripeCardForm';
import SrLink from 'client/components/SrLink/SrLink';

@withTransitionHook
@allowedRoles({
  roles: ALL_USER_ROLES,
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_JOIN_SUNROOM_CLUB)
@withApiState({
  joinSunroomClubApiState: {
    action: SR_API_ACTION_JOIN_SUNROOM_CLUB,
  },
})
@branch({
  currentUserRoles: ['currentUser', 'roles'],
})
@withScrollToTop
class JoinSunroomClubPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Select | Sunroom Rentals',
    keywords: 'sunroom, select',
    description: 'Join Sunroom Select to get perks & your dream home!',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    joinSunroomClubApiState: PropTypes.object.isRequired,
    currentUserRoles: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
  };

  _onPaymentFormSubmit = (source) => {
    const { dispatch, history } = this.props;

    dispatch(joinSunroomClubAction, {
      source,
    })
      .then(() => {
        history.push('/join-sunroom-club/paid');
      })
      .catch((error) => {
        log.error(error);
      });
  };

  render() {
    const { currentUserRoles, joinSunroomClubApiState } = this.props;

    if (hasRoleSunroomClub(currentUserRoles)) {
      return <Redirect to="/profile" />;
    }

    return (
      <div className="page-stripePayment">
        <Navbar
          leftButton={
            <SrLink className="link back" restoreScrollPosition redirectToLastLocation to="/feed" />
          }
        />
        <div className="formProgressive">
          <div className="contentContainer">
            <div className="fieldsContainer">
              <span className="title">
                Pay ${SUNROOM_CLUB_MEMBERSHIP_FEE} to join
                <br />
                Sunroom Select
              </span>
              <span className="label">
                Get <span className="bold color-green">50%</span> off all application fees
              </span>
            </div>
            <SrStripeCardForm
              onSubmit={this._onPaymentFormSubmit}
              isSubmitting={joinSunroomClubApiState.inProgress}
              submitErrorMessage={
                joinSunroomClubApiState.error
                  ? 'Sorry, the card did not work. Please try another card.'
                  : null
              }
            />
          </div>
        </div>
        <TabBar />
      </div>
    );
  }
}

JoinSunroomClubPage.displayName = 'JoinSunroomClubPage';

export default JoinSunroomClubPage;
